export default __webpack_public_path__ + "themes/_global/img/logo-w.png";